import type { ChangeEvent } from '@brighterly/lib-core-types/ui/inputs/interfaces'
import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface NationalityReturn {
  mode: ComputedRef<InputMode>
  setNationality: (event: ChangeEvent) => void
}

export const useNationality = (): NationalityReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const mode = computed(() => getMode(tutorApplicationStore.getShowErrors && !tutorApplicationStore.getNationality))

  const setNationality = (event: ChangeEvent) => {
    tutorApplicationStore.setNationality(event.value)
  }

  return {
    mode,
    setNationality,
  }
}
